import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import EnrollPlanChoice from './routes/EnrollPlanChoice'
import Terms from './routes/Terms'
import NewPlanAccepted from './routes/NewPlanAccepted'
import NoAvailablePrinter from './routes/NoAvailablePrinter'

const EnrollPlan = () => (
  <Switch>
    <Route key='enrollPlan' path={ROUTES.profile.enrollPlan.root} component={EnrollPlanChoice} exact />
    <Route key='enrollPlanTerms' path={ROUTES.profile.enrollPlan.terms} component={Terms} exact />
    <Route key='enrollPlanAccepted' path={ROUTES.profile.enrollPlan.accepted} component={NewPlanAccepted} exact />
    <Route key='enrollPlanNoAvailablePrinter' path={ROUTES.profile.enrollPlan.noAvailablePrinter} component={NoAvailablePrinter} exact />
  </Switch>
)

export default EnrollPlan
